import React from "react";

/**
 * KpiCard — polished KPI tile. Mirrors mobile KpiCard.tsx.
 *
 * Optional `onClick` turns the tile into a keyboard-accessible button
 * with pointer cursor and a subtle hover elevation, so KPIs can drill
 * into their filtered detail views.
 */
const VARIANT = {
    brand:     { bg: "#E6F1DE", fg: "#2E7E22" },
    attention: { bg: "#FEEDE5", fg: "#B45309" },
    navy:      { bg: "#E1E6F0", fg: "#131B2F" },
    neutral:   { bg: "#F1F3F7", fg: "#4B5565" },
};

export default function KpiCard({ label, value, helper, icon: Icon, variant = "brand", testid, onClick, ariaLabel }) {
    const v = VARIANT[variant];
    const common = "bg-white border border-[#E5E7EB] rounded-[20px] p-5 flex flex-col gap-2 min-w-[200px]";
    const inner = (
        <>
            <div className="flex items-center justify-between">
                <div className="text-xs text-[#4B5565] uppercase tracking-[0.08em] font-medium">{label}</div>
                <span
                    className="w-8 h-8 rounded-md flex items-center justify-center shrink-0"
                    style={{ background: v.bg, color: v.fg }}
                >
                    <Icon size={16} strokeWidth={1.75} />
                </span>
            </div>
            <div className="text-3xl text-[#131B2F] font-medium tracking-tight mt-1">{value}</div>
            {helper && <div className="text-sm text-[#4B5565]">{helper}</div>}
        </>
    );
    if (onClick) {
        return (
            <button
                type="button"
                onClick={onClick}
                data-testid={testid}
                aria-label={ariaLabel || label}
                className={`${common} text-left cursor-pointer transition-all hover:shadow-md hover:border-[#131B2F]/30 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#3E9E2E] focus-visible:ring-offset-2`}
            >
                {inner}
            </button>
        );
    }
    return (
        <div className={common} data-testid={testid}>
            {inner}
        </div>
    );
}
